import Vue from 'vue'
import Vuex from 'vuex'
import CorpusLoader from '../api/corpus_loader'

Vue.use(Vuex)

// function make_country_map(country) {
//   let n = {}
//   for(let i in country) {
//     const k = country[i]['value'].toLowerCase()
//     const v = country[i]['text']
//     n[k] = v
//   }
//   return n
// }

export default new Vuex.Store({
  state: {
    corpus: {},
    // country: [],
    // countryMap: {},
    sexMap: {'f': 'Female', 'm': 'Male'},
    loading_queue: []
  },
  mutations: {
    setCorpus(state, payload) {
      // state.country = payload.country
      // state.countryMap = make_country_map(payload.country)
      state.corpus = payload.corpus
      // console.log('setcorpus triggered')
    },
    addLoading(state, payload) {
      state.loading_queue.push(payload.queue)
    },
    removeLoading(state, payload) {
      const queue = payload.queue
      const qIndex = state.loading_queue.indexOf(queue)
      state.loading_queue.splice(qIndex, 1)
    }
  },
  actions: {
    async loadCorpus({commit}) {
      // const country = await CorpusLoader.loadCountry()
      commit('addLoading', {queue: 'corpus'})
      const corpus = await CorpusLoader.loadCorpus()
      commit('setCorpus', {'corpus': corpus })
      commit('removeLoading', {queue: 'corpus'})
    }
  },
  modules: {
  }
})
